"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryDialogsProvider = void 0;
const fragments_1 = require("../../fragments");
const media_library_uploader_provider_1 = require("./media-library-uploader.provider");
const types_1 = require("./types");
class MediaLibraryDialogsProvider extends media_library_uploader_provider_1.MediaLibraryUploaderProvider {
    static async openMediaDialog(parentVueInstance, dialogName, props) {
        const mediaLibraryFragment = await this.getMediaLibraryFragment();
        return new Promise(async (resolve, reject) => {
            try {
                const mountUtils = fragments_1.MountUtils.createInstance(parentVueInstance);
                this.mountedDialogs[dialogName] = await mountUtils.mountDialog(mediaLibraryFragment, mediaLibraryFragment[dialogName], props, () => {
                    resolve(null);
                    delete this.mountedDialogs[dialogName];
                });
                this.mountedDialogs[dialogName].resolve = resolve;
            }
            catch (error) {
                reject(error);
                this.closeMediaDialog(dialogName, null);
                console.error(error);
            }
        });
    }
    static async closeMediaDialog(dialogName, model) {
        var _a, _b, _c;
        await ((_b = (_a = this.mountedDialogs[dialogName]) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 ? void 0 : _b.call(_a, model));
        await ((_c = this.mountedDialogs[dialogName]) === null || _c === void 0 ? void 0 : _c.close());
        delete this.mountedDialogs[dialogName];
    }
    static async openChooseAudioFromLibraryDialog(parentVueInstance, selectedItemIdentifier) {
        return this.openMediaDialog(parentVueInstance, 'chooseFromLibraryDialog', {
            selectedItemIdentifier,
            component: types_1.MediaLibraryComponentType.audioLibraryPage
        });
    }
    static async openChooseVideoFromLibraryDialog(parentVueInstance, selectedItemIdentifier) {
        return this.openMediaDialog(parentVueInstance, 'chooseFromLibraryDialog', {
            selectedItemIdentifier,
            component: types_1.MediaLibraryComponentType.videoLibraryPage
        });
    }
    static async openChooseImageFromLibraryDialog(parentVueInstance, selectedItemIdentifier, shouldShareStore) {
        return this.openMediaDialog(parentVueInstance, 'chooseFromLibraryDialog', {
            selectedItemIdentifier,
            shouldShareStore,
            component: types_1.MediaLibraryComponentType.imageLibraryPage
        });
    }
    static async openChooseImageFromStockLibraryDialog(parentVueInstance, shouldShareStore) {
        return this.openMediaDialog(parentVueInstance, 'chooseFromLibraryDialog', {
            showImageStockLibrary: true,
            shouldShareStore,
            component: types_1.MediaLibraryComponentType.imageStockLibrary
        });
    }
    static async openChooseDocumentFromLibraryDialog(parentVueInstance, selectedItemIdentifier, allowedFormats) {
        return this.openMediaDialog(parentVueInstance, 'chooseFromLibraryDialog', {
            selectedItemIdentifier,
            component: types_1.MediaLibraryComponentType.documentsLibraryPage,
            allowedFormats
        });
    }
    static async closeChooseFromLibraryDialog(mediaEntity) {
        await this.closeMediaDialog('chooseFromLibraryDialog', mediaEntity);
    }
    static async openVideoRecordingDialog(parentVueInstance) {
        return this.openMediaDialog(parentVueInstance, 'videoRecordingDialog');
    }
    static async closeVideoRecordingDialog(model) {
        await this.closeMediaDialog('videoRecordingDialog', model);
    }
    static async openTrimMediaDialog(parentVueInstance, mediaType, mediaSrc, isNewRecording = false) {
        return this.openMediaDialog(parentVueInstance, 'trimMediaDialog', {
            mediaType,
            mediaSrc,
            isNewRecording
        });
    }
    static async closeTrimMediaDialog(model) {
        await this.closeMediaDialog('trimMediaDialog', model);
    }
    static async openTextToSpeechDialog(parentVueInstance, category, audioSrc) {
        return this.openMediaDialog(parentVueInstance, 'textToSpeechDialog', {
            category,
            audioSrc
        });
    }
    static async closeTextToSpeechDialog(model) {
        await this.closeMediaDialog('textToSpeechDialog', model);
    }
    static async openSubtitlesDialog(parentVueInstance, videoId, courseId, contentBlockId) {
        await this.openMediaDialog(parentVueInstance, 'subtitlesDialog', {
            videoId,
            courseId,
            contentBlockId
        });
    }
    static async closeSubtitlesDialog() {
        await this.closeMediaDialog('subtitlesDialog');
    }
}
exports.MediaLibraryDialogsProvider = MediaLibraryDialogsProvider;
